module.exports = __webpack_public_path__ + "img/arBannerD.ed1e6b04.png";